import React, { useState } from 'react';
import { Component } from 'react';
import {useNavigate} from 'react-router-dom';
import { useShop } from './shopinfo';
import SafeDisplayText from './displaytexthtml';



const AGB = () => {
 
  const { shopData } = useShop();

  //console.log("Current shop data:", shopData); 

  if (!shopData) return (<div>
                            <div className="mainContentWrapper">
                              <div className="contentContainer">
                                <div className="landingPageText">
                                    <br />
                                    <h4>AGB vom Demotestshop</h4>
                                    <br />
                                    Dieser Text wird angezeigt, wenn keine ID übermittelt wird.
                                    <br />
                                    
                                
                                </div>
                              </div>
                            </div>
                          </div>  
                      );
  
  return (
              <div>
                <div className="mainContentWrapper">
                  <div className="contentContainer">
                      <div className="landingPageText">
                          <br />
                          <h4>Allgemeine Geschäftsbedingungen</h4>
                          <br />
                          
                          <SafeDisplayText html={shopData.agb} />
                      
                      </div>
                    </div>
                  </div>
              </div>  


  );
};

export default AGB;

